import React, { Fragment } from 'react'
import { useCard, CardProps } from './useCard'
import blockContentToHtml from '@sanity/block-content-to-html'
import styles from './Card.module.scss'

const Card: React.FC<CardProps> = (props: CardProps) => {
  const { isAr, supportSocials, t } = useCard(props)

  return (
    <div className={styles['support-card']}>
      <h3>{t('donationMethods')}</h3>
      {supportSocials && supportSocials.length ? (
        supportSocials.map((item, index) => {
          const description = isAr ? item.descriptionAr : item.descriptionEn

          return (
            <div
              key={`support-item-${item.id}-${index}`}
              className={styles.item}
            >
              <div className={styles['icon-box']}>
                <img src={item.image} width={35} height={35} />
              </div>
              <div className={styles.content}>
                <h4>{isAr ? item.titleAr : item.titleEn}</h4>
                {description ? (
                  <p
                    className={styles.description}
                    dangerouslySetInnerHTML={{
                      __html: Array.isArray(description)
                        ? blockContentToHtml({
                            blocks: description,
                          })
                        : `<p>${description}</p>`,
                    }}
                  ></p>
                ) : (
                  <Fragment />
                )}
              </div>
            </div>
          )
        })
      ) : (
        <div className='col-12 text-center fs-4 fw-bold'>{t('noData')}</div>
      )}
    </div>
  )
}

export default Card
